function e(e){return e&&"function"==typeof e.schedule}export{e as isScheduler};
